<template>
  <main>
    <h1>&nbsp;</h1>
  </main>
</template>

<script>
export default {
  name: 'FrontPage',
};
</script>
